import React, {useRef, useEffect, useState} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Col} from '@modifi/ui'

import {SeparatorWrapper, Separator, DummySpan} from './styles'
import {useScreenWidth} from '../../common-components/screen-size-helper'

const propTypes = {
  cardType: PropTypes.string.isRequired,
}
const defaultProps = {}

export type SeparatorColProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const SeparatorCol: React.FC<SeparatorColProps> = ({cardType}) => {
  const colRef = useRef() as React.MutableRefObject<HTMLInputElement>
  const screenWidth = useScreenWidth()
  const [showSeparator, setShowSeparator] = useState(true)

  useEffect(() => {
    const prevElementTop = colRef?.current?.previousElementSibling?.getBoundingClientRect()?.top
    const nextElementTop = colRef?.current?.nextElementSibling?.getBoundingClientRect()?.top

    // checking if top position of previous and next item ( the cards ) are same., if so we show connector
    // when the next item falls into next line the top position condition does not match and we do not need to show the connector
    // the connector has to be shown always on md below screen always
    if (prevElementTop === nextElementTop || screenWidth! < 767) {
      setShowSeparator(true)
    } else {
      setShowSeparator(false)
    }
  }, [screenWidth, cardType])

  return (
    <DummySpan ref={colRef}>
      {showSeparator && (
        <Col col={12} md="auto">
          <SeparatorWrapper cardType={cardType}>
            <Separator />
          </SeparatorWrapper>
        </Col>
      )}
    </DummySpan>
  )
}

SeparatorCol.propTypes = propTypes

SeparatorCol.defaultProps = defaultProps

export default SeparatorCol
